export interface StandAccessModel {
  // General access section.
  canReadStands: boolean;
  canReadStandsById: boolean;
  canReadEquipmentOfStand: boolean;
  canWriteStands: boolean;
  canReadReceiptOfStand: boolean;
  canWriteReceiptOfStand: boolean;
  canSaveForce: boolean;
  canReadDebts: boolean;
  canWriteDebts: boolean;
  canChangeStandStatus: boolean;
  canRemoveTemplate: boolean;
}


export const STAND_ACCESS_DEFAULT: StandAccessModel = {
  canReadStands: false,
  canReadStandsById: false,
  canChangeStandStatus: false,
  canReadEquipmentOfStand: false,
  canWriteStands: false,
  canSaveForce: false,
  canReadDebts: false,
  canWriteDebts: false,
  canReadReceiptOfStand: false,
  canWriteReceiptOfStand: false,
  canRemoveTemplate: false,
};
